import React, { useCallback } from "react";
import { useState } from "react";
import {
  Box,
  TextField,
  IconButton,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Pagination,
  ToggleButton,
  ToggleButtonGroup,
  Grid,
  InputBase,
  Typography,
  TablePagination,
  TableContainer,
  Popover,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { DebounceInput } from "react-debounce-input";
import ViewListIcon from "@mui/icons-material/ViewList";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import { styled, alpha } from "@mui/material/styles";
import Swap from "../assets/svgs/swap.svg";
import FilterAltRoundedIcon from "@mui/icons-material/FilterAltRounded";
import FilterPage from "./FilterPopup";
import { useUserContext } from "../modules/user/UserContext";
import IosShareRoundedIcon from "@mui/icons-material/IosShareRounded";
import theme from "../theme";
import Search from "./Search";
import { Distributor } from "../modules/distributor/distributorType/Distributor";
import { useFormik } from "formik";
import { FilterValues } from "./schema/EventFiltersType";
import { Exhibitor } from "../modules/exhibitor/exhibitorType/Exhibitor";
import { BookingsFilterValues } from "./schema/BookingFiltersType";
import BookingFilterPopup from "./BookingFilterPopup";
import ExportBooking from "./ExportBooking";
import ExhibitorPopupFilter from "./ExhibitorPopupFilter";
import { ExhibitorFilter } from "./schema/ExhibitorFilter";
import dayjs from "dayjs";

interface ControlPanelProps {
  handleSort?: (field: string) => void;
  view?: "list" | "grid";
  setView?: React.Dispatch<React.SetStateAction<"list" | "grid">>;
  isExhibitor?: boolean;
  pageType?: string;
  distributors?: Distributor[];
  exhibitors?: Exhibitor[];
  filters? : BookingsFilterValues | ExhibitorFilter;
  setFilters?: any;
  searchText: string;
  setSearchText: (searchText: string) => void;
}

const ControlPanel: React.FC<ControlPanelProps> = ({
  handleSort,
  view,
  setView,
  isExhibitor,
  pageType,
  distributors,
  exhibitors,
  filters,
  setFilters,
  searchText,
  setSearchText,
}) => {
  const { user,isAdmin } = useUserContext();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);



  const handleViewChange = (
    event: React.MouseEvent<HTMLElement>,
    nextView: "list" | "grid" | null
  ) => {
    if (nextView !== null && setView) {
      setView(nextView);
    }
  };

  // Handle opening the filter popover
  const handleFilterClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  // Handle closing the filter popover
  const handleFilterClose = () => {
    setAnchorEl(null);
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchText?.(value);
  };

  // console.log("llll",pageType)

  const filtersFormik = useFormik<FilterValues>({
    initialValues: {
      distributor: [],
      rating: "",
      startTime: dayjs().startOf("day").toISOString(), 
      endTime: "",
      event_type: "",
      broadcast_type: "",
    },
    // validationSchema: validationSchema,
    onSubmit: (values) => {
      const transformedValues = Object.fromEntries(
        Object.entries({
          ...values,
          distributor: {
            name: values.distributor.map((dist) => dist),
          },

          ...(values.startTime || values.endTime
            ? {
                startTime: {
                    ...(values.startTime && {$gte: values.startTime}),
                    ...(values.endTime && { $lte: values.endTime }),
                },
              }
            : {}),
          endTime:{}

        }).filter(([_, value]) =>
          Array.isArray(value) ? value.length > 0 : value
        )
      );
      setFilters(transformedValues);
      setAnchorEl(null);
    },
  });

  const filtersFormikBookings = useFormik<BookingsFilterValues>({
    initialValues: {
      exhibitor: [],
      booking_status: "",
      startTime: "",
      endTime: "",
      event_type: "",
      broadcast_type: "",
      payment_status: "",
    },
    onSubmit: (values) => {
      
      const filters: any = {};
      if (values.event_type) filters.event = { ...filters.event, event_type: values.event_type };
      if (values.broadcast_type) filters.event = { ...filters.event, broadcast_type: values.broadcast_type };
      if (values.startTime || values.endTime) {
        filters.event = {
          ...filters.event,
          startTime: {
            ...(values.startTime && { $gte: values.startTime }),
            ...(values.endTime && { $lte: values.endTime }),
          },
        };
      }
      if (values.payment_status) filters.payment_status = values.payment_status;
      if (values.booking_status) filters.booking_status = values.booking_status;
        const key = pageType === "users" ? "exhibitors" : "exhibitor";

    if (values.exhibitor && values.exhibitor.length > 0) {
      filters[key] = { name: [...values.exhibitor] };
    } else {
      delete filters[key];
    }

      setFilters({ ...filters }); 
      setAnchorEl(null);
    },
  });


  return (
    <Box
      display={"flex"}
      sx={{
        justifyContent: {
          xs: "space-between",
          sm: "space-between",
          md: "flex-end",
        },
        gap:{xs:'10px'},
        width:{xs:'100%',md:'auto'},
        flexDirection: { xs: "column", md: "row" },
        alignItems: "center",
      }}
      alignItems="start"
    >
      {/* Search Bar */}
      
      <Search searchText={searchText} setSearchText={setSearchText} />
     

      <Box sx={{display:'flex',justifyContent: {xs: "space-between"}, width:{xs:'100%'}}}>
         {/* Sort Button */}
      <Box display={"flex"} columnGap={"15px"} ml={2}>
        {(pageType !== "players" && pageType !== "users" && pageType !== "exhibitors") && (
          <StyledIconButton onClick={() => handleSort?.("")}>
            <Typography variant="body1" sx={{ mr: 2 }}>
              Sort
            </Typography>
            <img src={Swap} alt="Sort" style={{ verticalAlign: "middle" }} />
          </StyledIconButton>
        )}

        {/* Filter Button */}
        {pageType == "events" && (
          <StyledIconButton
            onClick={handleFilterClick}
            sx={{
              display: { xs: "none", sm: "flex" },
            }}
          >
            <Typography variant="body1" sx={{ mr: 2 }}>
              Filter
            </Typography>
            <FilterAltRoundedIcon />
          </StyledIconButton>
        )}

     {pageType === "players" && user?.role?.name !== "Exhibitor" && (
          <StyledIconButton
            onClick={handleFilterClick}
            sx={{
              display: { xs: "none", sm: "flex" },
            }}
          >
            <Typography variant="body1" sx={{ mr: 2 }}>
              Filter
            </Typography>
            <FilterAltRoundedIcon />
          </StyledIconButton>
        )}

        {pageType == "bookings" && (
          <StyledIconButton
            onClick={handleFilterClick}
            sx={{
              display: { xs: "none", sm: "flex" },
            }}
          >
            <Typography variant="body1" sx={{ mr: 2 }}>
              Filter
            </Typography>
            <FilterAltRoundedIcon />
          </StyledIconButton>
        )}

         {pageType == "users" && (
          <StyledIconButton
            onClick={handleFilterClick}
            sx={{
              display: { xs: "none", sm: "flex" },
            }}
          >
            <Typography variant="body1" sx={{ mr: 2 }}>
              Filter
            </Typography>
            <FilterAltRoundedIcon />
          </StyledIconButton>
        )}


        {/* {pageType == "exhibitors" && (
          <StyledIconButton
            onClick={handleFilterClick}
            sx={{
              display: { xs: "none", sm: "flex" },
            }}
          >
            <Typography variant="body1" sx={{ mr: 2 }}>
              Filter
            </Typography>
            <FilterAltRoundedIcon />
          </StyledIconButton>
        )} */}

        {isAdmin && pageType === "bookings" && (
         <ExportBooking filters={filters as BookingsFilterValues} searchText={searchText}/>
        )}
      </Box>
      {view && (
        <ToggleButtonGroup
          sx={{
            // display: { xs: "none", sm: "flex" },
            display:'flex'
          }}
          value={view}
          exclusive
          onChange={handleViewChange}
          aria-label="view"
        >
          <Box display="flex" alignItems="center" marginLeft={"20px"}>
            <Typography variant="body1" sx={{ mr: 0 }}>
              {" "}
              View :
            </Typography>
            <StyledToggleButton
              disableRipple
              value="list"
              aria-label="list view"
              sx={{ border: "none", paddingLeft: "5px", paddingRight: "5px" }}
            >
              <ViewListIcon />
            </StyledToggleButton>
            <StyledToggleButton
              disableRipple
              value="grid"
              aria-label="grid view"
              sx={{ border: "none", paddingLeft: "0px" }}
            >
              <ViewModuleIcon />
            </StyledToggleButton>
          </Box>
        </ToggleButtonGroup>
      )}

      </Box>
      {/* Filter Popover */}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleFilterClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        {/* Show the appropriate filter page based on the page type */}
        {pageType === "events" && (
          <FilterPage
            onClose={handleFilterClose}
            distributors={distributors}
            formik={filtersFormik}
          />
        )}

        {pageType === "bookings" && (
          <BookingFilterPopup
            onClose={handleFilterClose}
            exhibitors={exhibitors}
            formik={filtersFormikBookings}
          />
        )}

        {pageType === "players" && (
          <BookingFilterPopup
          onClose={handleFilterClose}
          exhibitors={exhibitors}
          formik={filtersFormikBookings}
          pageType="players"
        />
        )}

        {pageType === "users" && (
          <BookingFilterPopup
          onClose={handleFilterClose}
          exhibitors={exhibitors}
          formik={filtersFormikBookings}
          pageType="players"
        />
        )}

        {pageType === "exhibitors" && (
          <BookingFilterPopup
            onClose={handleFilterClose}
            exhibitors={exhibitors}
            formik={filtersFormikBookings}
            pageType="players"
          />
        )}
      </Popover>

    </Box>
  );
};

export default ControlPanel;

const StyledIconButton = styled(IconButton)({
  "&.MuiIconButton-root": {
    backgroundColor: "#fff",
    borderRadius: "25px",
    height: "44px",
    width: "107px",
  },
});

const StyledToggleButton = styled(ToggleButton)({
  "&.MuiToggleButton-root.Mui-selected": {
    backgroundColor: "transparent",
    color: "#ff0000",
  },
  "&.MuiToggleButton-root:hover": {
    backgroundColor: "transparent",
  },
});
